<template>
  <PflegeBaseSectionTemplate
    v-editable="props.blok"
    :background-color="getPflegeColornameFromHex(props.blok.backgroundColor.value)"
    :data-uid="props.blok._uid"
    :anchor="anchor"
    :text-align="props.blok.textAlign"
  >
    <template v-if="props.blok.media?.length > 0" #media>
      <Media
        v-for="asset in props.blok.media"
        :key="asset._uid"
        :blok="asset"
        :aspect-ratio="aspectRatios.m"
      />
    </template>

    <template v-if="props.blok.intro?.length > 0" #intro>
      <IntroComponent :blok="props.blok.intro[0]" />
    </template>

    <template v-if="props.blok.firstDivider?.length > 0" #firstDivider>
      <Divider :blok="props.blok.firstDivider[0]" />
    </template>

    <template v-if="props.blok.content?.length > 0" #content>
      <PflegeGridTemplate :blok-content="props.blok.content">
        <template #default="{ content }">
          <CardComponent :blok="content" />
        </template>
      </PflegeGridTemplate>
    </template>

    <template v-if="props.blok.secondDivider?.length > 0" #secondDivider>
      <Divider :blok="props.blok.secondDivider[0]" />
    </template>

    <template v-if="props.blok.closing?.length > 0" #closing>
      <ClosingComponent :blok="props.blok.closing[0]" />
    </template>

    <template v-if="props.blok.thirdDivider?.length > 0" #thirdDivider>
      <Divider :blok="props.blok.thirdDivider[0]" />
    </template>
  </PflegeBaseSectionTemplate>
</template>

<script setup>
import { WPElementMedia } from '@webcarelbj/shared-bloks'
import { findComponent } from '@webcarelbj/shared-components'

const Media = findComponent(WPElementMedia)

const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
})
const anchor = computed(() => {
  return props.blok.intro?.length > 0 && props.blok.intro[0].anchor !== null
    ? props.blok.intro[0].anchor
    : ''
})
const { getPflegeColornameFromHex } = usePflegeUtils()
</script>
